import { render, staticRenderFns } from "./ContextMenuTemplateComponent.vue?vue&type=template&id=7aabe95a&lang=pug"
import script from "./ContextMenuTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./ContextMenuTemplateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aabe95a')) {
      api.createRecord('7aabe95a', component.options)
    } else {
      api.reload('7aabe95a', component.options)
    }
    module.hot.accept("./ContextMenuTemplateComponent.vue?vue&type=template&id=7aabe95a&lang=pug", function () {
      api.rerender('7aabe95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/ContextMenuTemplateComponent.vue"
export default component.exports